import backend, {AGENTCORE_ENGINE_API, METRICS_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const getMetricsUrl = (path, queryParam) => {
  if (!METRICS_API) {
    throw new Error('REACT_APP_METRICS_API is not configured.');
  }

  const query = queryString.stringify(queryParam);

  return `${METRICS_API}${path}?${query}`;
};

const queryDailyClientMetrics = (dates) => {
  const url = getMetricsUrl('/metrics/client/daily_count', {
    dates: dates.join(','),
  });
  return backend.get(url);
};

const queryDailyClientLogsMetrics = (dates) => {
  const url = getMetricsUrl('/metrics/client/daily_logs', {
    dates: dates.join(','),
  });
  return backend.get(url);
};

// Returns {dates, snapshots} where snapshots hold the full financial snapshot
// records (forecast/actual weeks keyed by GGGGWeekWW) sorted by metricDate descending.
const queryFinancialSnapshots = (dates) => {
  const url = getMetricsUrl('/metrics/financial/snapshot', {
    dates: dates.join(','),
  });
  return backend.get(url);
};

// Agent report card rollups live in the AgentCore Engine API, not the metrics
// service, but share the metrics repo's daily_count date grammar.
const queryAgentReportCardMetrics = (dates, guideRn) => {
  const queryParam = {
    dates: dates.join(','),
    guideRn,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${AGENTCORE_ENGINE_API}/metrics/agent_report_card?${query}`;

  return backend.get(url);
};

export default {
  queryAgentReportCardMetrics,
  queryDailyClientMetrics,
  queryDailyClientLogsMetrics,
  queryFinancialSnapshots,
};
